import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import ImagePlaceholder from "../../../assets/img/img_placeholder.png";
import X from "../../../assets/img/x.png";
import FileUploadField from "../../../Common/FileUploadField";
import "./EmployementDetailsSection.css";

export default function EmploymentDetailsSection({
  employeeData,
  handleInputChange,
  manager,
  department,
  role,
  workLocations,
  filteredWorkLocations,
  handleWorkLocationChange,
  handleWorkLocationSelect,
  errors,
  photoLoad,
  deleteFile,
  btnClicked,
  generateEmployeeId,
}) {
  const [showWorkLocationDropdown, setShowWorkLocationDropdown] =
    useState(false);

  const preventLeadingSpace = (e) => {
    if (e.key === " " && e.currentTarget.value.length === 0) {
      e.preventDefault();
    }
  };
  return (
    <div
      className="bg-white p-4 shadow pb-5 rounded-3"
      style={{
        marginTop: "4rem",
        marginLeft: "0.8rem",
        marginRight: "0.8rem",
        marginBottom: "4rem",
      }}
    >
      {/* Section Heading */}
      <h4
        className="employment-details-heading text-capitalize border-bottom pb-3"
        style={{ fontFamily: "ErasDemiITC" }}
      >
        Employment Details
      </h4>
      <button
        type="button"
        className="btn"
        onClick={generateEmployeeId}
        style={{
          backgroundColor: btnClicked ? "#1564d5" : "#6c757d",
          color: "white",
        }}
      >
        <i className="bi bi-arrow-clockwise"></i> Generate ID
      </button>
      <div
        className="multisteps-form__content mt-3"
        style={{ fontFamily: "Calibri" }}
      >
        <Row>
          {/* Employee ID */}
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="icueEmpFormTypeInsured">
                Employee ID
              </Form.Label>
              <Form.Control
                value={employeeData.employee_id}
                onChange={(e) => handleInputChange(e, "employee")}
                onKeyDown={preventLeadingSpace}
                type="text"
                id="icueEmpFormTypeInsured"
                name="employee_id"
                className="text-uppercase icueEmpFormInput bg-white text-muted"
                isInvalid={!!errors.employee_id}
              />
              <Form.Control.Feedback type="invalid">
                {errors.employee_id}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          {/* Position */}
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="joining_position_select">
                Position
              </Form.Label>
              <Form.Select
                name="joining_position"
                id="joining_position_select"
                value={employeeData.joining_position || ""} // <-- FIX
                onChange={(e) => handleInputChange(e, "employee")}
                isInvalid={!!errors.joining_position}
              >
                <option value="" disabled>
                  Select Designation
                </option>
                {role.map((r) => (
                  <option key={r.role_id} value={r.role_name}>
                    {r.role_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.joining_position}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          {/* Department */}
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="department_select">Department</Form.Label>
              <Form.Select
                name="department"
                id="department_select"
                value={employeeData.department || ""} // <-- FIX
                onChange={(e) => handleInputChange(e, "employee")}
                isInvalid={!!errors.department}
              >
                <option value="" disabled>
                  Select Department
                </option>
                {department.map((dept) => (
                  <option key={dept.department_id} value={dept.department_name}>
                    {dept.department_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.department}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="manager_select">Select Manager</Form.Label>
              <Form.Select
                name="reporting_manager"
                id="manager_select"
                value={employeeData.reporting_manager || ""}
                onChange={(e) => handleInputChange(e, "employee")}
                isInvalid={!!errors.reporting_manager}
              >
                <option value="" disabled>
                  Select Manager
                </option>
                {manager.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.manager_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.reporting_manager}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          {/* Joining Date */}
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="joining_date_input">Joining Date</Form.Label>
              <Form.Control
                value={
                  employeeData.joining_date
                    ? new Date(employeeData.joining_date)
                        .toISOString()
                        .slice(0, 10)
                    : ""
                }
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="date"
                id="joining_date_input"
                name="joining_date"
                isInvalid={!!errors.joining_date}
              />
              <Form.Control.Feedback type="invalid">
                {errors.joining_date}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          {/* Work Location with Dropdown */}
          <Col md={3} style={{ position: "relative" }}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="work_location_input">
                Work Location
              </Form.Label>
              <Form.Control
                id="work_location_input"
                value={employeeData.work_location}
                onKeyDown={preventLeadingSpace}
                onChange={handleWorkLocationChange}
                onFocus={() => setShowWorkLocationDropdown(true)}
                onBlur={() => {
                  setTimeout(() => setShowWorkLocationDropdown(false), 150);
                }}
                type="text"
                name="work_location"
                placeholder="Type to search locations..."
                autoComplete="off"
                isInvalid={!!errors.work_location}
              />
              <Form.Control.Feedback type="invalid">
                {errors.work_location}
              </Form.Control.Feedback>
              {showWorkLocationDropdown && (
                <ul
                  style={{
                    position: "absolute",
                    top: "calc(100% - 0.5rem)",
                    left: "0",
                    right: "0",
                    backgroundColor: "white",
                    border: "1px solid #ced4da",
                    borderRadius: "0.25rem",
                    maxHeight: "200px",
                    overflowY: "auto",
                    listStyleType: "none",
                    padding: 0,
                    margin: 0,
                    zIndex: 1000,
                  }}
                >
                  {filteredWorkLocations.length > 0 ? (
                    filteredWorkLocations.map((location, index) => (
                      <li
                        key={index}
                        onClick={() => handleWorkLocationSelect(location)}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          textTransform: "capitalize",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f8f9fa")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "white")
                        }
                      >
                        {location}
                      </li>
                    ))
                  ) : (
                    <li
                      style={{
                        padding: "8px 12px",
                        color: "#6c757d",
                        cursor: "default",
                      }}
                    >
                      No locations found
                    </li>
                  )}
                </ul>
              )}
            </Form.Group>
          </Col>

          {/* Employment Type */}
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="employee_type_select">
                Employment Type
              </Form.Label>
              <Form.Select
                value={employeeData.employee_type}
                onChange={(e) => handleInputChange(e, "employee")}
                id="employee_type_select"
                name="employee_type"
                isInvalid={!!errors.employee_type}
              >
                <option value="">Select Type</option>
                <option value="FullTimeEmployee">Full Time Employee</option>
                <option value="Trainee">Trainee</option>
                <option value="Internship">Internship</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.employee_type}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          {/* Shift Time */}
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="shift_timing_select">Shift Time</Form.Label>
              <Form.Select
                value={employeeData.shift_timing}
                onChange={(e) => handleInputChange(e, "employee")}
                id="shift_timing_select"
                name="shift_timing"
                isInvalid={!!errors.shift_timing}
              >
                <option value="">Select Shift</option>
                <option value="morning">Morning</option>
                <option value="evening">Evening</option>
                <option value="night">Night</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.shift_timing}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="attendance_type_select">
                Attendance Type
              </Form.Label>
              <Form.Select
                name="attendance_type"
                id="attendance_type_select"
                value={employeeData.attendance_type || ""}
                onChange={(e) => handleInputChange(e, "employee")}
                isInvalid={!!errors.attendance_type}
              >
                <option value="">Select Attendance Type</option>
                <option value="Biometric">Biometric</option>
                <option value="Manual">Manual</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.attendance_type}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          {/* Role Name */}
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="role_name_select">Role</Form.Label>
              <Form.Select
                name="role_name"
                id="role_name_select"
                value={employeeData.role_name || ""}
                onChange={(e) => handleInputChange(e, "employee")}
                isInvalid={!!errors.role_name}
              >
                <option value="">Select Role</option>
                <option value="Employee">Employee</option>
                <option value="Manager">Manager</option>
                {/* <option value="HR">HR</option> */}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.role_name}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          {/* Salary Fields */}
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="basic_salary_input">Basic Salary</Form.Label>
              <Form.Control
                value={employeeData.basic_salary}
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="number"
                id="basic_salary_input"
                name="basic_salary"
                isInvalid={!!errors.basic_salary}
              />
              <Form.Control.Feedback type="invalid">
                {errors.basic_salary}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="hra_input">HRA</Form.Label>
              <Form.Control
                value={employeeData.hra}
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="number"
                id="hra_input"
                name="hra"
                isInvalid={!!errors.hra}
              />
              <Form.Control.Feedback type="invalid">
                {errors.hra}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="conveyance_input">Conveyance</Form.Label>
              <Form.Control
                value={employeeData.conveyance_allowance}
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="number"
                id="conveyance_input"
                name="conveyance_allowance"
                isInvalid={!!errors.conveyance_allowance}
              />
              <Form.Control.Feedback type="invalid">
                {errors.conveyance_allowance}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="special_allowance_input">
                Special Allowance
              </Form.Label>
              <Form.Control
                value={employeeData.special_allowance}
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="number"
                id="special_allowance_input"
                name="special_allowance"
                isInvalid={!!errors.special_allowance}
              />
              <Form.Control.Feedback type="invalid">
                {errors.special_allowance}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="gross_salary_input">Gross Salary</Form.Label>
              <Form.Control
                value={employeeData.gross_salary}
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="number"
                id="gross_salary_input"
                name="gross_salary"
                isInvalid={!!errors.gross_salary}
              />
              <Form.Control.Feedback type="invalid">
                {errors.gross_salary}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="provident_fund_input">
                Provident Fund
              </Form.Label>
              <Form.Control
                value={employeeData.provident_fund}
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="number"
                id="provident_fund_input"
                name="provident_fund"
                isInvalid={!!errors.provident_fund}
              />
              <Form.Control.Feedback type="invalid">
                {errors.provident_fund}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="esi_input">ESI</Form.Label>
              <Form.Control
                value={employeeData.ESI}
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="number"
                id="esi_input"
                name="ESI"
                isInvalid={!!errors.ESI}
              />
              <Form.Control.Feedback type="invalid">
                {errors.ESI}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="inhand_salary_input">Total CTC</Form.Label>
              <Form.Control
                value={employeeData.inhand_salary}
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="number"
                id="inhand_salary_input"
                name="inhand_salary"
                isInvalid={!!errors.inhand_salary}
              />
              <Form.Control.Feedback type="invalid">
                {errors.inhand_salary}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          {/* References */}
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="reference1_input">Reference 1</Form.Label>
              <Form.Control
                value={employeeData.reference1}
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="text"
                id="reference1_input"
                name="reference1"
                isInvalid={!!errors.reference1}
              />
              <Form.Control.Feedback type="invalid">
                {errors.reference1}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="reference2_input">Reference 2</Form.Label>
              <Form.Control
                value={employeeData.reference2}
                onKeyDown={preventLeadingSpace}
                onChange={(e) => handleInputChange(e, "employee")}
                type="text"
                id="reference2_input"
                name="reference2"
                isInvalid={!!errors.reference2}
              />
              <Form.Control.Feedback type="invalid">
                {errors.reference2}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          {/* File Upload */}
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="policicue_offer_letter_upload">
                Upload Policicue Offer Letter
              </Form.Label>
              <FileUploadField
                name="policicue_offer_letter"
                value={employeeData.policicue_offer_letter}
                onChange={(e) => handleInputChange(e, "employee")}
                onDelete={() => deleteFile("policicue_offer_letter")}
                error={errors.policicue_offer_letter}
                isLoading={photoLoad}
                placeholder={ImagePlaceholder}
                deleteIcon={X}
              />
            </Form.Group>
          </Col>
        </Row>
      </div>
    </div>
  );
}
